import React, { useEffect, useState } from "react";
import { startLoader, stopLoader } from "../../../lib/utils";
import { updatePassword } from "../../../features/employees/helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";

const ProfileSettings = (props) => {

  const [currentElementId, setCurrentElementId] = useState();
  const [isButtonLock,setButtonLock] = useState(true);
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const {user,token} = isAuthenticated();
  
  const toggleInputFields = (id) => {
    setCurrentElementId(id);
  }

  const handleChange = (type) => (event) => {
    if (type === "password") {
      setPassword(event.target.value);
    }
  };
  
  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  } 


  function isValidPassword(password) {
    if (/\s/.test(password)) {
      new Toast({
        type:'warning',
        message:"Password contains space ❌",
        duration:1000
      })
      return false;
    }

    if (password.length < 8) {
      new Toast({
        type:'warning',
        message:"Password must be at least 8 characters ❌",
        duration:1000
      })
      return false;
    }

    return true;
}


  const handleSavProfile = async event => {
    try{
      if(!isValidPassword(password)) return;
      await startLoader();

      let payload = {
        newPassword:password, confirmPassword:password
      };

      const response = await updatePassword(user._id,token,payload);

      if(response.error){
        new Toast({
          type:"error",
          message:"Password not updated",
          duration:1000
        })
      }else{
        new Toast({
          type:"success",
          message:"Password updated successfully",
          duration:1000
        })
        props.handleCloseModal()
      }
    }catch(error){
      
    }

    await stopLoader();
  }


  useEffect(()=>{
    if(password.length > 0){
      setButtonLock(false)
    }else{
      setButtonLock(true)
    }
  },[password])

  return(
    <div className={window.innerWidth < 768 ? "w-full h-full" : "modal-test-container d-flex"}>
      <div className={window.innerWidth < 768 ? "w-full h-full" : "profile-settings-modal slideBottomToTop flex-item"}>
        {
          window.innerWidth > 767 && (
            <div className="modal-header space-between" style={{height:"64px", background:"var(--darkBlue)"}}>
              <p className="flex-item fs-18 font-weight-700 color-white">Profile Settings</p>
              <div onClick={()=>props.handleCloseModal()} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div style={{padding:"12px"}}>
          <div className="d-flex space-between w-full">
            <div onClick={()=>toggleInputFields("changed-invoice-date")} className={`${currentElementId == "changed-invoice-date" || password ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: (currentElementId == "changed-invoice-date" || password) ? "1px solid var(--darkBlue)" : "", width:"86%"}}>
              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "changed-invoice-date" || password) ? "4px" : ""}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "changed-invoice-date" || password) ? "12px" : "16px", lineHeight: (currentElementId == "changed-invoice-date" || password) ? "12px" : "14px", color: (currentElementId == "changed-invoice-date" || password) ? "var(--darkBlue)" : "", transition: "180ms" }}>Update / Change Password</p>
              </div>
              <input id="changed-invoice-date" value={password} onChange={handleChange("password")} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'changed-invoice-date' || password) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type={isPasswordVisible ? "text" : "password"} placeholder='Enter Password' />
            </div>
            <div onClick={()=>togglePasswordVisibility()} className='d-flex cursor-pointer' style={{width:"40px", height:"40px", borderRadius:"100%", background:"#ffffff", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)"}}>
              {
                isPasswordVisible ? (
                  <svg className='flex-item margin-auto' width="20" height="20" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="var(--darkBlue)"/>
                  </svg>
                ) : (
                  <svg className='flex-item margin-auto' width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.854511 0.14662C0.808029 0.100136 0.752848 0.0632624 0.692117 0.0381053C0.631386 0.0129482 0.566295 4.89791e-10 0.500561 0C0.434826 -4.89792e-10 0.369735 0.0129482 0.309004 0.0381053C0.248274 0.0632624 0.193092 0.100136 0.146611 0.14662C0.100129 0.193104 0.0632585 0.248289 0.038103 0.309024C0.0129474 0.369758 -4.89761e-10 0.434853 0 0.500592C4.89761e-10 0.566331 0.0129474 0.631426 0.038103 0.69216C0.0632585 0.752895 0.100129 0.80808 0.146611 0.854564L3.64612 4.35229C1.91316 5.53475 0.706634 7.34358 0.280592 9.39789C0.267199 9.46217 0.266597 9.52845 0.278819 9.59296C0.291042 9.65747 0.315851 9.71894 0.351828 9.77386C0.387806 9.82879 0.434248 9.87608 0.488503 9.91305C0.542759 9.95003 0.603764 9.97595 0.668037 9.98934C0.73231 10.0027 0.798592 10.0033 0.863097 9.99112C0.927603 9.97889 0.98907 9.95408 1.04399 9.9181C1.09891 9.88212 1.1462 9.83568 1.18317 9.78142C1.22014 9.72716 1.24606 9.66615 1.25945 9.60187C1.45084 8.67863 1.82421 7.80276 2.35776 7.02539C2.89131 6.24803 3.57435 5.58473 4.36701 5.07423L5.94979 6.65611C5.53728 6.95201 5.19408 7.33413 4.944 7.77595C4.69393 8.21777 4.54297 8.70871 4.5016 9.21471C4.46023 9.72071 4.52943 10.2297 4.70442 10.7062C4.8794 11.1828 5.15597 11.6156 5.51494 11.9746C5.87391 12.3336 6.30668 12.6102 6.78323 12.7852C7.25977 12.9602 7.76869 13.0294 8.27466 12.988C8.78063 12.9466 9.27154 12.7957 9.71333 12.5456C10.1551 12.2955 10.5372 11.9523 10.8331 11.5397L15.1455 15.8534C15.2394 15.9473 15.3667 16 15.4994 16C15.6322 16 15.7595 15.9473 15.8534 15.8534C15.9473 15.7595 16 15.6322 16 15.4994C16 15.3666 15.9473 15.2393 15.8534 15.1454L0.854511 0.14662ZM8.12348 6.00316L11.486 9.36589C11.4521 8.48486 11.087 7.64907 10.4636 7.02562C9.8402 6.40218 9.00446 6.03702 8.12348 6.00316ZM5.52985 3.41036L6.33274 4.2133C6.87698 4.07157 7.43711 3.99999 7.9995 4.00032C11.205 4.00032 14.0556 6.32713 14.7385 9.60187C14.7656 9.73182 14.8432 9.8457 14.9542 9.91846C15.0652 9.99121 15.2005 10.0169 15.3305 9.98984C15.4604 9.96279 15.5743 9.88523 15.647 9.77422C15.7198 9.66321 15.7455 9.52783 15.7184 9.39789C14.9415 5.67318 11.692 3.00039 7.9995 3.00039C7.14462 3.00039 6.31174 3.14338 5.52985 3.41036Z" fill="var(--darkBlue)"/>
                  </svg>
                )
              }
            </div>
          </div>
          <div onClick={isButtonLock?null:handleSavProfile} className={`member-button-global ${isButtonLock? 'member-button-global-inactive' : ''} btn-center button-red d-flex flex-item m-t-20`} style={{width:"100%",pointerEvents:!isButtonLock?'auto':'none', boxShadow:"0px 0px 8px rgba(0,0,0,0.25)", background:isButtonLock ? "#9a9a9a" : "var(--darkBlue)"}}>
            <p className='flex-item font-weight-700' style={{fontSize:"16px", color:!isButtonLock && "#ffffff"}}>Save Changes</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileSettings;